import React, { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import useApp from '../../store/app/appContext';
import PageWrapper from './PageWrapper';
import ACTIONS from '../../store/actions';
import { API_BASE_URL } from "../../config";

function LoginRedirect() {
  const { dispatch } = useApp();

  const { token } = useParams();

  useEffect(() => {
    if(token) {
      axios.defaults.headers.common['x-access-token'] = token;
      localStorage.setItem('jwtToken', token);
      axios.get(`${API_BASE_URL}/user/me`).then(res => {
        const response = res.data;
        dispatch({
          type: ACTIONS.AUTHENTICATE_COMPLETE,
          payload: response.data
        })
      })
      
    }
  }, [dispatch, token])
 
  return (
    <PageWrapper/>
  );
}

export default LoginRedirect;
